import React, { Component } from 'react'
import _ from 'lodash'
import { StyledTimerBox } from '../styled/StyledQuestionComponents';
import TimerIcon from './Icons/TimerIcon';



class Timer extends Component {
    constructor(props) {
        super(props)
        this.state = {
           
        }     
              
    }

 
    render(){    
        const {minutes, seconds, isSummary} = this.props
         return (
           <StyledTimerBox
                 isSummary={isSummary}
           >
              <div className={'row'}>
                    <div className='icon'><TimerIcon width={40} /></div>
                    <div className='counter'>
                            <div>
                              <span className={'coundown-box'}>
                              {
                                  minutes < 10 ?
                                   '0' + minutes 
                                  :
                                     minutes 
                                  }
                              </span> 
                              :
                              <span className={'coundown-box'}> 
                              {
                                  seconds < 10 ?
                                   '0' + seconds 
                                  :
                                     seconds 
                                  
                              }
                              </span>
                            </div> 
                    </div>
                </div>     
           </StyledTimerBox>
         )
    }
}

export default Timer



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/QuestionsNew/_components/Timer.js